import { formatDateTime } from '../utils/datetime';

interface SuccessViewProps {
  signedAt?: number;
  signatureUrl?: string;
}

/** The post-submit "已签字" success state. */
export default function SuccessView({ signedAt, signatureUrl }: SuccessViewProps) {
  return (
    <div className="success">
      <div className="success__check" aria-hidden="true">
        ✓
      </div>
      <p className="success__title">已签字</p>
      {typeof signedAt === 'number' && (
        <p className="success__time">签字时间：{formatDateTime(signedAt)}</p>
      )}
      {signatureUrl && (
        <div className="success__sig">
          <img src={signatureUrl} alt="签名" className="success__sigimg" />
        </div>
      )}
    </div>
  );
}
